import { render, staticRenderFns } from "./BlocksRenderer.vue?vue&type=template&id=5a4638f8&lang=pug&"
import script from "./BlocksRenderer.vue?vue&type=script&lang=js&"
export * from "./BlocksRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports